import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Indlæser...")
  ])
], -1)
const _hoisted_4 = [
  _hoisted_3
]


import { useQuery, useResult } from "@vue/apollo-composable";
import { KLODSER_I_SAET_FOR_UUID_OPSLAG } from "@/constants/graphql";
import Klodstabel from "@/components/base/Klodstabel.vue";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'LegoSetKlodser',
  props: {
    uuid: null
  },
  setup(__props: any) {

const props = __props as {
  uuid: string;
}



const { result: klodsResult, loading: klodserLoading } = useQuery(
  KLODSER_I_SAET_FOR_UUID_OPSLAG,
  props
);

const klodser = useResult(klodsResult, null, data => data.klodser);

function visKlodser(tekst: string) {
  router.push({ name: "klodsmednavn", params: { soegetekst: tekst } });
}

return (_ctx: any,_cache: any) => {
  return (!_unref(klodserLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Klodstabel, {
          klodsliste: _unref(klodser),
          "vis-antal-i-saet": true,
          "vis-overskrift": true,
          onSoegKlodsnavn: _cache[0] || (_cache[0] = navn => visKlodser(navn))
        }, null, 8, ["klodsliste"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
}
}

})